<template>
  <v-layout row xs12>
    <Loading :value="loading"></Loading>
    <v-dialog v-model="dialogAjoutBudget" max-width="60%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Ajouter des budgets </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex>
              <data-tables :data="listeTypeTravaux" style="width: 100%">
                <el-table-column
                  prop="annee"
                  label="MOIS ANNEE (AAAA-MM)"
                  width="300"
                >
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.annee }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column prop="libelle" label="LIBELLE" width="300">
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.libelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="montant"
                  label="MONTANT (FCFA)"
                  width="200"
                >
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.montant }}
                    </v-chip>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>

          <!-- <div class="text-xs-right"> -->

          <v-layout row class="text-xs-right">
            <v-flex xs2>
              <!-- <v-tooltip top> -->
              <v-btn
                @click="closeDialog()"
                slot="activator"
                icons
                block
                color="orange"
                dark
                >Anuller <v-icon right>remove_circle</v-icon></v-btn
              >
              <!-- <v-btn slot="activator" icons block  @click="closeDialog()" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn> -->
              <!-- <span>Annuler</span> -->
              <!-- </v-tooltip> -->
            </v-flex>

            <v-flex xs2>
              <!-- <v-tooltip top> -->
              <v-btn
                slot="activator"
                icons
                block
                color="green"
                @click="saveListe()"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
              <!-- <span>Enregistrer les produits</span>
                            </v-tooltip> -->
            </v-flex>
          </v-layout>
          <!-- </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: "LoadConducteurExcel",
  components: { Loading },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idChantier: {
      type: Number
    },
    typeTrx: {
      type: Number
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      dialogAjoutBudget: false,
      loading: false
    };
  },
  watch: {
    show: function(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutBudget = true;
      } else {
        this.dialogAjoutBudget = false;
        this.$emit("close");

        // window.location.reload()
      }
    }
  },
  methods: {
    saveListe() {
      // this.loadPage()
      this.loading = true;
      let succesEnreg = true;
      let url =
        this.domaine +
        "budgetChantier/save/liste_Budget/excel/" +
        this.idChantier;
      let nbData = 10;
      let nbReq = 1;
      let ligne = null;

      let nbRest;
      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        let data = new FormData();
        for (let prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[annee][]", ligne.annee);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[montant][]", ligne.montant);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("idUser", this.user.id);
        data.append("typeTravauxId", this.typeTrx);

        this.$http.post(url, data).then(
          resp => {
            this.loading = false;
            succesEnreg = false;
            this.$emit("close");
            this.dialogAjoutBudget = false;
            // this.loadListeTravaux()
            this.$notify({
              title: "Enregistrement",
              message: "La liste a ete enregistre avec succes",
              type: "success",
              position: "top-right",
              duration: 7000
            });
          },
          error => {
            this.loading = false;
            succesEnreg = false;
            this.dialogAjoutBudget = false;
            this.$message.error(
              "Erreur lors de l'enregistrement des types travaux"
            );
          }
        );
      }

      //  this.loading = true
      // const loading = this.$loading({
      //     lock: true,
      //     text: 'Veuillez patientez ...',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // })
    },

    loadListeTravaux() {
      this.loading = true;
      let url = this.domaine + "budgetChantier/chantier/" + this.chantier.id;
      this.$http.get(url).then(
        resp => {
          this.loading = false;
          this.tableListeTrxBudget = resp.body.listeTypeTrx;
          this.totalMntPropose = resp.body.totalMntPropose;
          this.totalMntValide = resp.body.totalMntValide;
          this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation"
          );
        }
      );
    },

    closeDialog() {
      this.$emit("close");
      // this.loadListeTravaux()
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/boardChantier/loadBudget.vue